import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setSearchCriteria"] = "searchCriteria/setSearchCriteria";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setSearchCriteria: createAction(ActionTypes.setSearchCriteria, (data) => ({
        payload: data
    }))
};
